import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { RemovePermissionsActionDefinitionModel } from 'src/app/models/api/playbooks/actions/removePermissionsProperties';
import { TriggerTypes } from 'src/app/models/api/playbooks/triggers/triggerTypes.enum';
import { PlaybooksActionDefinitionInput } from 'src/app/models/componentInputs/playbookActionInput.interface';

@Component({
  selector: 'app-remove-permissions-action',
  templateUrl: './remove-permissions-action.component.html',
  styleUrls: ['./remove-permissions-action.component.scss'],
})
export class RemovePermissionsActionComponent implements OnInit {
  @Input() public fg: UntypedFormGroup;
  @Input() public playbooksActionInput: PlaybooksActionDefinitionInput;
  @Input() public triggerType: TriggerTypes;
  public hasChange = false;

  private _removePermissionsActionDefinitionModel?: RemovePermissionsActionDefinitionModel;

  ngOnInit(): void {
    if (this.playbooksActionInput.actionDefinitionProperties) {
      this._removePermissionsActionDefinitionModel = this.playbooksActionInput
        .actionDefinitionProperties as RemovePermissionsActionDefinitionModel;
      this._removePermissionsActionDefinitionModel.removeOrgWideAccess = true; // Currently this is the only option
    }

    this.fg.addControl('removeOrgWideAccess', new UntypedFormControl(true, [Validators.required]));
  }
}
